import { motion } from 'motion/react'

const MotionContainer = ({ children }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 0.4,
        scale: { type: 'tween', visualDuration: 0.4, bounce: 0.5 },
      }}
    >
      {children}
    </motion.div>
  )
}

export default MotionContainer
